<template>
  <div>
    <Modal :mask-closable="false" title="编辑课后视频" v-model="visible" width="600px" @on-ok="saveData">
      <Form ref="videoForm" class="form"
            :model="formData" :rules="videoRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="教材版本" prop="version" :label-width="100">
              <Select :transfer="true" v-model.number="formData.version" disabled clearable @on-change="onVersionChange">
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="选择开始Level" prop="levelId" :label-width="100">
              <Select :transfer="true" v-model.number="formData.levelId" disabled clearable filterable @on-change="onLevelChange">
                <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="选择对应课程" prop="lessonId" :label-width="100">
              <Select :transfer="true" v-model.number="formData.lessonId" disabled clearable filterable>
                <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="上传视频" :label-width="100" prop="videoUrl">
              <el-upload
                class="upload-demo"
                :action="$appConfig.baseUrl + '/upload/fileUpload'"
                :on-change="handleChange"
                :on-success="handleSuccess"
                :headers="headers"
                :on-progress="handleProgress"
                :before-upload="beforeUpload"
                accept="video/*"
                :limit="2"
                multiple
                :file-list="fileList">
                <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
              </el-upload>
              <el-button size="small" style="float: right;position: absolute;top: 0px;left: 80px;" v-if="formData.videoUrl" @click="showIndex(formData.videoUrl)"><i class="el-icon-view el-icon--left"></i>预览</el-button>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="每课一曲" :label-width="100" prop="musicUrl">
              <el-upload
                class="upload-demo"
                :action="$appConfig.baseUrl + '/upload/fileUpload'"
                :on-change="handleChangeMusic"
                :on-success="handleSuccessMusic"
                :headers="headers"
                :on-progress="handleProgress"
                :before-upload="beforeUpload"
                accept="video/*"
                :limit="2"
                multiple
                :file-list="fileMusicList">
                <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
              </el-upload>
              <el-button size="small" style="float: right;position: absolute;top: 0px;left: 80px;" v-if="formData.musicUrl" @click="showIndex(formData.musicUrl)"><i class="el-icon-view el-icon--left"></i>预览</el-button>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingUpdate" @click="saveData">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    components: {},
    name: 'LessonVideoUpdateModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      },
      id: {
        type: Number
      }
    },
    data () {
      return {
        levels: [],
        lessons: [],
        headers: {},
        fileList: [],
        fileMusicList: [],
        loadingUpdate: false,
        formData: {
          lessonId: null,
          levelId: null,
          videoUrl: '',
          musicUrl: '',
          version: null,
          id: null
        },
        visible: this.value,
        videoRule: {
          version: [
            { type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }
          ],
          lessonId: [
            { type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' },
          ],
          levelId: [
            { type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      showIndex (videoUrl) {
        if (videoUrl) {
          window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()))
        }
      },
      handleChange (file, fileList) {
        this.fileList = fileList.slice(-1)
      },
      handleChangeMusic (file, fileList) {
        this.fileMusicList = fileList.slice(-1)
      },
      handleSuccess (res, file, fileList) {
        this.formData.videoUrl = res.data.name
        // this.videoUrl = res.data.url
      },
      handleSuccessMusic (res, file, fileList) {
        this.formData.musicUrl = res.data.name
        // this.musicUrl = res.data.url
      },
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      handleProgress (event, file, fileList) {
        if (event.percent === 100) {
          event.percent = 99
        }
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
      },
      saveData () {
        let self = this
        self.loadingUpdate = true
        self.$refs.videoForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingUpdate = false
            return
          }
          self.$http.post('/bookLessonVideo/update', self.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('编辑成功!')
              self.loadingUpdate = false
              self.visible = false
              self.successCallback()
            }
          }).catch(function (e) {
            self.loadingUpdate = false
            self.$Message.error(e.msg)
          })
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.levels = []
          this.lessons = []
          this.fileList = []
          this.fileMusicList = []
          this.formData = {}
          this.$emit('on-close', val)
        }
      },
      id (val) {
        if (val) {
          let self = this
          self.$http.get('/bookLessonVideo/queryById?lessonId=' + val).then(function (res) {
            if (res.data) {
              if (res.data.id) {
                self.formData.id = res.data.id
              }
              self.formData.videoUrl = res.data.videoUrl
              self.formData.musicUrl = res.data.musicUrl
              self.formData.version = res.data.materialVersion
              self.formData.levelId = parseInt(res.data.levelId)
              self.formData.lessonId = parseInt(res.data.lessonId)
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonVideoUpdateModal.vue?e39d65a0